"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.graphQLErrors = exports["float"] = exports.tableSticky = exports.tableColumns = exports.render = exports.textTransform = exports.textAlign = exports.dropdownOption = exports.appNavData = exports.moment = exports.rowColProps = exports.rowColPropsSizesBool = exports.rowColPropsSizesStringOrNumber = exports.stringOrNumberOrBoolean = exports.stringOrBoolean = exports.stringOrNumber = exports.ref = exports.attachedVertical = exports.attachedHorizontal = exports.attached = exports.directionVertical = exports.directionHorizontal = exports.directionAll = exports.icon = exports.as = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // as


var as = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]); // icon


exports.as = as;

var icon = _propTypes["default"].oneOfType([_propTypes["default"].oneOf(_constants.ICON_NAMES), _propTypes["default"].node]); // direction


exports.icon = icon;

var directionAll = _propTypes["default"].oneOf(_constants.DIRECTION_ALL);

exports.directionAll = directionAll;

var directionHorizontal = _propTypes["default"].oneOf(_constants.DIRECTION_HORIZONTAL);

exports.directionHorizontal = directionHorizontal;

var directionVertical = _propTypes["default"].oneOf(_constants.DIRECTION_VERTICAL); // attached


exports.directionVertical = directionVertical;

var attached = _propTypes["default"].oneOfType([_propTypes["default"].bool, directionAll]);

exports.attached = attached;

var attachedHorizontal = _propTypes["default"].oneOfType([_propTypes["default"].bool, directionHorizontal]);

exports.attachedHorizontal = attachedHorizontal;

var attachedVertical = _propTypes["default"].oneOfType([_propTypes["default"].bool, directionVertical]); // ref


exports.attachedVertical = attachedVertical;

var ref = _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]);

exports.ref = ref;

var stringOrNumber = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]);

exports.stringOrNumber = stringOrNumber;

var stringOrBoolean = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]);

exports.stringOrBoolean = stringOrBoolean;

var stringOrNumberOrBoolean = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].bool]); // row col


exports.stringOrNumberOrBoolean = stringOrNumberOrBoolean;

var rowColPropsSizesStringOrNumber = _propTypes["default"].shape({
  xs: stringOrNumber,
  sm: stringOrNumber,
  md: stringOrNumber,
  lg: stringOrNumber,
  xl: stringOrNumber
});

exports.rowColPropsSizesStringOrNumber = rowColPropsSizesStringOrNumber;

var rowColPropsSizesBool = _propTypes["default"].shape({
  xs: _propTypes["default"].bool,
  sm: _propTypes["default"].bool,
  md: _propTypes["default"].bool,
  lg: _propTypes["default"].bool,
  xl: _propTypes["default"].bool
});

exports.rowColPropsSizesBool = rowColPropsSizesBool;

var rowColProps = _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].array, rowColPropsSizesBool]); // moment object


exports.rowColProps = rowColProps;

var moment = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].object, _propTypes["default"].instanceOf(Date)]); // app nav data


exports.moment = moment;

var appNavData = _propTypes["default"].arrayOf(_propTypes["default"].shape({
  disabled: _propTypes["default"].bool,
  title: _propTypes["default"].string,
  tooltip: _propTypes["default"].string,
  icon: icon,
  value: _propTypes["default"].string,
  data: appNavData
})); // dropdown option


exports.appNavData = appNavData;

var dropdownOption = _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([stringOrNumber, _propTypes["default"].shape({
  value: _propTypes["default"].any,
  label: stringOrNumber,
  name: stringOrNumber,
  text: stringOrNumber,
  title: stringOrNumber,
  disabled: _propTypes["default"].bool
})])); // text align


exports.dropdownOption = dropdownOption;

var textAlign = _propTypes["default"].oneOf(_constants.TEXT_ALIGNS); // text transform


exports.textAlign = textAlign;

var textTransform = _constants.TEXT_TRANSFORMS.reduce(function (result, t) {
  var output = result;
  output[t] = _propTypes["default"].bool;
  return output;
}, {}); // render props


exports.textTransform = textTransform;

var render = _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]); // table


exports.render = render;

var tableColumns = _propTypes["default"].arrayOf(_propTypes["default"].shape({
  header: render,
  headerProps: _propTypes["default"].shape({
    colSpan: _propTypes["default"].number,
    rowSpan: _propTypes["default"].number
  }),
  selector: as,
  footer: render,
  footerProps: _propTypes["default"].shape({
    colSpan: _propTypes["default"].number,
    rowSpan: _propTypes["default"].number
  }),
  render: render,
  // onSort: PropTypes.func, // only for body
  onClick: _propTypes["default"].func,
  // only for body
  columns: tableColumns
}));

exports.tableColumns = tableColumns;

var tableSticky = _propTypes["default"].arrayOf(_propTypes["default"].oneOf(_constants.ORDER_TYPES)); // float


exports.tableSticky = tableSticky;
var _float = directionHorizontal; // graphQLErrors

exports["float"] = _float;

var graphQLErrors = _propTypes["default"].shape({
  data: _propTypes["default"].object,
  errorInfo: _propTypes["default"].string,
  errorType: _propTypes["default"].oneOf(_constants.ERROR_TYPES),
  locations: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    line: _propTypes["default"].number,
    column: _propTypes["default"].number,
    sourceName: _propTypes["default"].string
  })),
  message: _propTypes["default"].string,
  path: _propTypes["default"].arrayOf(_propTypes["default"].string)
});

exports.graphQLErrors = graphQLErrors;